var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cmp-order-saleunit"},[_c('span',{directives:[{name:"translation",rawName:"v-translation",value:({ type: 'label', code: 'label_sale_unit' } ),expression:"{ type: 'label', code: 'label_sale_unit' } "}],staticClass:"sale-unit-label"}),_c('span',{staticClass:"sale-unit-value"},[_vm._v(_vm._s(_vm.saleUnit))])])
}
var staticRenderFns = []

export { render, staticRenderFns }